import {createContext, useContext, useEffect, useState} from "react";
import { AuthContext } from "./authContext";
import { API_BASE_URL, API_KEY } from "../config/config";
import axios from "axios";
import {useParams} from "react-router-dom";

const VideoItemContext = createContext(null);

const VideoItemProvider = ({ children }) => {
	const {visitor} = useContext(AuthContext);
	const [video, setVideo] = useState(null);

	const { videoTitleId } = useParams();

	let videoId = null;

	if (videoTitleId) {
		const urlPattern = /^([\w-]+)\.(\d+)$/;
		const match = videoTitleId.match(urlPattern);
		if (match) {
			const [_, videoTitle, matchVideoId] = match;
			if (matchVideoId) {
				videoId = Number(matchVideoId);
			}
		}
	}

	const fetchVideo = async () => {
		if (!visitor) return;

		if (!videoId) return;

		if (video !== null) return; // Already load

		try {
			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${API_BASE_URL}/videos/${videoId}`,
				headers: {
					'XF-Api-Key': API_KEY,
					'XF-Api-User': visitor.user_id,
				},
				withCredentials: true,
			};

			const response = await axios.request(config);
			const fetchedVideo = response.data.video;
			setVideo(fetchedVideo);
		} catch (error) {
			console.error('Failed to fetch video:', error);
		}
	};

	useEffect(() => {
		if (visitor && videoId) {
			fetchVideo();
		}
	}, [visitor, videoId]);

	return (
		<VideoItemContext.Provider
			value={{
				video
			}}
		>
			{children}
		</VideoItemContext.Provider>
	);
};

export { VideoItemContext, VideoItemProvider };
